import React, { useContext, useMemo } from 'react';
import { DateTime } from 'luxon';
import { Tooltip, Typography } from '@kareo/design-system';
import { StyledAlert } from '../../../utils/styledFacesheet';
import { CACHED_DATA_MESSAGE } from '../../../service/patient/types';
import { CACHED_DATA_TOOLTIP_MESSAGE } from '../../../service/facesheet/types';
import { TimezoneContext } from '../../Facesheet/Container/Facesheet';
var CachedDataWarning = function (_a) {
    var messageType = _a.messageType, lastCachedDate = _a.lastCachedDate, displayBorder = _a.displayBorder, displayTextOnly = _a.displayTextOnly, showTooltipInfo = _a.showTooltipInfo, addSuffix = _a.addSuffix;
    var timeZone = useContext(TimezoneContext);
    var formattedCachedTime = useMemo(function () {
        try {
            return (DateTime.fromISO(lastCachedDate, { zone: 'utc' })
                .setZone(timeZone)
                .toFormat("LLL dd 'at' hh:mm a") || lastCachedDate);
        }
        catch (error) {
            return lastCachedDate;
        }
    }, [lastCachedDate]);
    var message = lastCachedDate
        ? messageType + " " + formattedCachedTime + (addSuffix ? CACHED_DATA_MESSAGE.WITH_DATE_SUFFIX : '')
        : CACHED_DATA_MESSAGE.NO_DATE;
    var tooltipTitle = showTooltipInfo ? CACHED_DATA_TOOLTIP_MESSAGE : '';
    return (React.createElement(Tooltip, { title: tooltipTitle }, displayTextOnly ? (React.createElement(Typography, { variant: "body2", component: "div" }, message)) : (React.createElement(StyledAlert, { severity: "warning", displayBorder: displayBorder }, message))));
};
export default CachedDataWarning;
